import React, { useCallback, useEffect, useState } from 'react';
import * as styles from './SocialMediaMobile.module.scss';

const { __ } = window.wp.i18n;

interface SocialMediaProps {
    id: string;
    title: string;
    location: string;
}

let emailSubject = __('Check this job out', 'cg-jobs');
let emailBody = __('Hey there,\n\nI just came across this job and thought you might find it interesting.\n\n', 'cg-jobs');
let emailBody2 = __('Cheers!', 'cg-jobs');

export const SocialMediaMobile: React.FC<SocialMediaProps> = React.memo((props) =>{

    useEffect(() => {
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                // if (node instanceof HTMLElement && node.classList.contains('offcanvas-backdrop')) {
                //   const bgOverlay = document.querySelector('.offcanvas-backdrop') as HTMLElement;
                //   if(bgOverlay) {
                //     bgOverlay.style.backgroundColor = "rgb(45 78 96 / 75%)";
                //     bgOverlay.style.opacity = '1';
                //     bgOverlay.style.backdropFilter = 'blur(4px)';
                //   }
                // }
                if (node instanceof HTMLElement && node.classList.contains('modal-backdrop')) {
                    const bgOverlay2 = document.querySelector('.modal-backdrop') as HTMLElement;
                    if(bgOverlay2) {
                      bgOverlay2.style.backgroundColor = "rgb(45 78 96 / 75%)";
                      bgOverlay2.style.opacity = '1';
                      bgOverlay2.style.backdropFilter = 'blur(4px)';
                    }
                  }
                
              });
            }
          }
        });
    
        // Start observing the document body
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
    
        // Cleanup on component unmount
        return () => {
          observer.disconnect();
        };
      }, []);

    const modalStyle = {
        textAlign: 'center',
        borderRadius: '4px',
        overflow: 'hidden',
        border: 'none',
        maxWidth: '380px',
        margin: 'auto'
    }

    function copyLink() {
        const linkToCopy = window.location.href; // Gets the current Job URL
        navigator.clipboard.writeText(linkToCopy).then(function() {
            const message = document.getElementById('copyMessage');
            if(message){
                message.style.display = 'inline';
                setTimeout(() => {
                    message.style.display = 'none';
                }, 2000);
            }
        }, function(err) {
            console.error('Failed to copy: ', err);
        });
    }

    const generateMailToLink = () => {
        const subject = encodeURIComponent(emailSubject);
        const body = encodeURIComponent(emailBody + window.location.href + '\n\n' + emailBody2);
        return `mailto:?subject=${subject}&body=${body}`;
    }



  return (
    <div className="modal fade" id="socialMediaModal" tabIndex={-1} aria-labelledby="socialMediaModalLabel" aria-hidden="true">
        <div className={[styles['modal-dialog-wrapper'], `modal-dialog modal-dialog-centered`].join(' ')}>
            <div className="modal-content" style={{...modalStyle, textAlign: 'center'}}>
            <div className={styles['modal-head']}>
                <h5 id="socialMediaModalLabel">{props.title}</h5>
                <div className={styles['location']}>{props.location}</div>
            </div>

            <div className={styles['social-media']}>
                <ul>
                    <li className={styles['link']}> 
                        <button type="button" onClick={copyLink} aria-label={__( 'Copy link', 'cg-jobs' )}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"  xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.82754 12.7733L7.76688 13.834C6.30242 15.2984 3.92805 15.2984 2.46358 13.834C0.999118 12.3695 0.999118 9.99514 2.46358 8.53067L3.52424 7.47001M13.0702 8.53067L14.1308 7.47001C15.5953 6.00554 15.5953 3.63118 14.1308 2.16671C12.6664 0.702243 10.292 0.702243 8.82754 2.16671L7.76688 3.22737M5.67221 10.6253L10.9222 5.37532" stroke="#0070AD" stroke-width="1.43427" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> 
                        </button>  
                        <span id="copyMessage" className={styles['copyMessage']} style={{display: 'none'}}>{ __( 'Link copied!', 'cg-jobs' ) }</span>  
                    </li>
                    <li className={styles['email']}>
                        <a href={generateMailToLink()} target="_blank" rel="noopener noreferrer" aria-label={__('Share via email', 'cg-jobs')}>
                            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="16.2917" height="11.5" rx="0.941791" stroke="#0070AD" stroke-width="1.50687" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.5635 1.65137L9.16518 7.70803L1.72852 1.65137" stroke="#0070AD" stroke-width="1.50687" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </li>
                    <li className={styles['facebook']}>
                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target='_blank' aria-label={__( 'Share on Facebook', 'cg-jobs' )}>
                            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg" target="_blank">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.06851 18V9.78966H8.81611L9.23798 6.58774H6.06851V4.54327C6.06851 3.6238 6.31731 2.98558 7.64784 2.98558H9.34616V0.129808C9.05409 0.0865385 8.04808 0 6.87981 0C4.4351 0 2.75841 1.49279 2.75841 4.22957V6.58774H0V9.78966H2.75841V18H6.06851Z" fill="#0070AD"/>
                            </svg>
                        </a>
                    </li>
                    <li className={styles['linkedin']}>
                        <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}&title=Check%20this%20out&summary=${encodeURIComponent(props.title)}&source=`} target="_blank" aria-label='Share on LinkedIn'>
                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.87981 3.49404C3.0547 3.49404 3.79028 2.71758 3.78006 1.74702C3.76984 0.75602 3.0547 0 1.90025 0C0.756012 0 0 0.75602 0 1.74702C0 2.71758 0.725363 3.49404 1.85938 3.49404H1.87981ZM8.78684 14.9979V9.34815C8.78684 9.04165 8.81749 8.74537 8.89922 8.52061C9.14441 7.91784 9.69609 7.29463 10.6258 7.29463C11.8415 7.29463 12.3319 8.22433 12.3319 9.58313V14.9979H15.6931V9.1949C15.6931 6.08909 14.0381 4.63835 11.8211 4.63835C10.0935 4.63835 9.28795 5.55117 8.83506 6.23808L8.78634 6.31272L8.78684 4.87333H5.42565C5.42565 4.87333 5.46652 5.82346 5.42565 14.9979H8.78684ZM3.56672 14.9998V4.87531H0.195312V14.9998H3.56672Z" fill="#0070AD"/>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
            <div className={styles['close-social-modal']}>          
                <button type="button" data-bs-dismiss="modal" aria-label="Close">{ __( 'Cancel', 'cg-jobs' ) }</button>
            </div> 
            </div>
        </div>
    </div>
)});